import { render } from "./stock-info-modal.vue?vue&type=template&id=97dab066&scoped=true"
import script from "./stock-info-modal.vue?vue&type=script&lang=js"
export * from "./stock-info-modal.vue?vue&type=script&lang=js"

import "./stock-info-modal.vue?vue&type=style&index=0&id=97dab066&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97dab066"]])

export default __exports__